import { Box, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import {
  formatOverallGradeDisplay,
  resolveExposureLimitsForOverallGrade,
} from './calc/exposureGradeLimits';

function UnderwritingFinalScoreSummary({
  totals,
  gradeThresholds = null,
  emptyText = 'Upload cohort data to compute the underwriting score.',
  showBorder = true,
  mt = 6,
}) {
  const exposureGradeLimits =
    totals?.overallGrade != null
      ? resolveExposureLimitsForOverallGrade(totals.overallGrade, gradeThresholds)
      : null;

  return (
    <Box
      mt={mt}
      pt={showBorder ? 5 : 0}
      borderTopWidth={showBorder ? '1px' : 0}
      borderColor="gray.200"
    >
      <Text fontSize="sm" fontWeight="semibold" mb={1}>
        Final score
      </Text>
      {totals ? (
        <>
          <Text fontSize="2xl" fontWeight="bold" className="brand">
            {formatOverallGradeDisplay(totals.overallGrade)}
          </Text>
          {totals.scorePercentOfMax != null ? (
            <Text fontSize="sm" color="gray.500" mt={1}>
              {`${(totals.scorePercentOfMax * 100).toFixed(1)}% of maximum score`}
              {exposureGradeLimits
                ? ` · Exposure limits: run rate ≤ ${exposureGradeLimits.runRateMaxPct}%, runoff ≤ ${exposureGradeLimits.runoffMaxPct}%`
                : ''}
            </Text>
          ) : null}
        </>
      ) : (
        <Text fontSize="sm" color="gray.500">
          {emptyText}
        </Text>
      )}
    </Box>
  );
}

UnderwritingFinalScoreSummary.propTypes = {
  totals: PropTypes.object,
  gradeThresholds: PropTypes.object,
  emptyText: PropTypes.string,
  showBorder: PropTypes.bool,
  mt: PropTypes.number,
};

export default UnderwritingFinalScoreSummary;
